import {connect, useDispatch} from "react-redux";
import React, {useEffect, useState} from "react";
import './style.scss';
import {setPersonalNoteIsBusy, setPersonalNoteIsOpen} from "../../../../redux/actions/notes";
import AlertConfirmModal from "../../../common/AlertConfirmModal";

const PersonalNotes = ({
    su= null,
    isBusy,
    activeNote,
}) => {

    const dispatch = useDispatch();
    const [note, setNote] = useState('');
    const [showAlert, setShowAlert] = useState(false);

    useEffect(() => {
        if (activeNote && activeNote.hasOwnProperty('note')) {
            setNote(activeNote.note);
        }

    }, []);

    const handleNoteChange = (e) => {
        setNote(e.target.value);
    }

    const handleBackToSidebar = () => {
        dispatch(setPersonalNoteIsOpen(false));
        dispatch(setPersonalNoteIsBusy(false));
    };


    const handleSave = async () => {
        dispatch(setPersonalNoteIsBusy(true));
        await axios.post('/api/update-subscriber-note', {
            su_id: su.id,
            updated_note: note,
        }).then((response) => {
            dispatch(setPersonalNoteIsBusy(false));
            setNote(note);
            setShowAlert(true);
        })
            .catch((error) => {
                console.log('Cannot save personal note');
            });
    }

    const handleClear = async () => {
        setNote('');
    }

    return <>
        <div className={'personal-notes-header'}>
            <div className="active-user-name" style={{padding: '10px'}}>
                <div className="current-user">
                    <div className="title" style={{ fontWeight: 'bold', fontSize: '20px' }}>
                        <a href={`/${su.login}`}> {su.login} </a>
                    </div>
                </div>
            </div>
            <div className={'header-container'}>
                <div className="personal-note-back-btn back-btn" onClick={handleBackToSidebar}>
                    <i className="fa-regular fa-chevron-left" />
                </div>
                <div className="title" style={{ fontWeight: 'bold', fontSize: '20px' }}>Personal Notes</div>
                <div className={'action-btns'}>
                    <button className={'btn btn-outline-dark'} onClick={handleClear}>Clear</button>
                    <button className={'btn btn-primary'} onClick={handleSave} disabled={isBusy || showAlert}>Save</button>
                </div>
            </div>
        </div>
        <div className={'personal-notes-container'}>
            <textarea name={'note'} className={'notes'} value={note} onChange={handleNoteChange} disabled={isBusy}></textarea>
        </div>

        {showAlert && <AlertConfirmModal modalBody={`Personal note to ${su.login} successfully saved.`} show={showAlert} setShow={setShowAlert} />}
    </>
};

function mapStateToProps(state) {
    return {
        isBusy: state.notes.isBusy,
        activeNote: state.notes.activeNote,
    };
}

export default connect(mapStateToProps)(React.memo(PersonalNotes));
